import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RecommendationType } from '../../../../models/consultation-recommendation.model';
import { environment } from '../../../../../environments/environment';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
    standalone: false,
    selector: 'cva-consultation-recommendations',
    templateUrl: './consultation-recommendations.component.html',
    styleUrl: '../consultation-tab-view.component.scss',
    animations: [
        trigger('slideSwitch', [
            transition('* => *', [
                style({ transform: 'translateX(-10px)', opacity: 0 }),
                animate('250ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
            ])
        ])
    ],

})
export class ConsultationRecommendationsComponent {
    @Input() selectedRecommendation: RecommendationType | null = null;
    @Input() practitionerId: string;
    @Input() patientId: string;
    @Input() notesApproved = false;
    @Input() patientAge: string = ''
    @Output() closeDrawer = new EventEmitter<void>();

    RecommendationType = RecommendationType;

    cvaUI_url = environment.cvaUI_url;
    isDrawerIconBlinking = false;

    onCloseClick() {
        this.closeDrawer.emit();
    }
}
